<div
    class="container-fluid well"
    data-test-automation="surveyor-details">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <div class="col-xs-6">
                        <label
                            class="control-label"
                            for="firm"
                            >Preallocated survey firm</label
                        >
                        <div
                            class="input-group"
                            [ngClass]="{'has-error': getModel().firm.firmName !== undefined && firmInput.invalid && firmInput.dirty}">
                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                            <input
                                type="text"
                                id="firm"
                                #firmInput="ngModel"
                                name="firmName"
                                [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                class="form-control"
                                [(ngModel)]="getModel().firm.firmName"
                                readonly
                                data-test-automation="firm-name" />
                        </div>
                        @if (getModel().firm !== undefined && firmInput.errors && firmInput.dirty) {
                            <div class="help-block">
                                <span>Error!</span>
                                <span>No preallocated survey firm found.</span>
                            </div>
                        }
                    </div>
                }
                <div class="col-xs-6">
                    <label
                        class="control-label required-input"
                        for="surveyor"
                        >Preallocated surveyor name</label
                    >
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div
                            class="input-group"
                            [ngClass]="{'has-error': (surveyor | formFieldHasError) || !surveyorIsSelected}">
                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                            <input
                                type="text"
                                id="surveyor"
                                name="surveyor"
                                #surveyor="ngModel"
                                class="form-control"
                                [ngModel]="getSelectedSurveyor()"
                                placeholder="Search preallocated surveyor"
                                nlrFocus
                                required
                                autocomplete="off"
                                (ngModelChange)="surveyorChange()"
                                [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                [nlrTypehead]="filterSurveyorsByFullName"
                                (itemSelected)="surveyorSelected($event)"
                                title="Select the preallocated surveyor name"
                                data-test-automation="surveyor" />
                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-search"></i></span>
                        </div>
                    }
                    <!--                    <div class="help-block"-->
                    <!--                         *ngIf="!planInformationForm.surveyor.$error.required && planInformationForm.surveyor.$error.notSelected && planInformationForm.surveyor.$dirty">-->
                    <!--                        <span>Error!</span>-->
                    <!--                        <span>Preallocated surveyor name not found.</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidSurveyorDetailsText}}</span>-->
<!--</div>-->
